import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/report-payroll-details', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = (templateId, attributes = {}) => {
  return httpClient
    .post(
      '/api/report-payroll-details/export',
      { template_id: templateId, ...attributes },
      { responseType: 'arraybuffer' }
    )
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, exportExcel }
